import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight, FiArrowRight } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [showCursor, setShowCursor] = useState(true);
  
  const fullText = "ni Shammy";
  
  // Stats with counting effect
  const [pureStat, setPureStat] = useState(0);
  const [varietiesStat, setVarietiesStat] = useState(0);
  const [customersStat, setCustomersStat] = useState(0);

  // Start typing effect after 1 second (reduced from 5s for better UX)
  useEffect(() => {
    const typingTimer = setTimeout(() => {
      setIsTyping(true);
    }, 1000); // Start after 1 second instead of 5

    return () => clearTimeout(typingTimer);
  }, []);

  // Fixed typing effect - simpler and more reliable
  useEffect(() => {
    let timer;
    
    if (isTyping && text.length < fullText.length) {
      timer = setTimeout(() => {
        setText(fullText.substring(0, text.length + 1));
      }, 150);
    } else if (isTyping && text.length === fullText.length) {
      // Finished typing, hide cursor after 2 seconds
      timer = setTimeout(() => {
        setShowCursor(false);
      }, 2000);
    }
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [text, isTyping, fullText]);

  // Counting effect for stats
  useEffect(() => {
    const pureInterval = setInterval(() => {
      setPureStat(prev => {
        if (prev < 100) return prev + 1;
        clearInterval(pureInterval);
        return 100;
      });
    }, 20);

    const varietiesInterval = setInterval(() => {
      setVarietiesStat(prev => {
        if (prev < 50) return prev + 1;
        clearInterval(varietiesInterval);
        return 50;
      });
    }, 40);

    const customersInterval = setInterval(() => {
      setCustomersStat(prev => {
        if (prev < 1000) return prev + 10;
        clearInterval(customersInterval);
        return 1000;
      });
    }, 1);

    return () => {
      clearInterval(pureInterval);
      clearInterval(varietiesInterval);
      clearInterval(customersInterval);
    };
  }, []);

  return (
    <section className="hero-section">
      {/* Background Image */}
      <div className="hero-bg-image"></div>
      
      {/* Overlay Gradient */}
      <div className="hero-overlay"></div>

      <div className="hero-container">
        <div className="hero-content">
          {/* Main Title with Fixed Typing Effect */}
          <h1 className="hero-title">
            <span className="title-static">Spices</span>
            <span className="title-typing">{text}</span>
            {showCursor && <span className="cursor">|</span>}
          </h1>

          {/* Two-line Tagline */}
          <div className="tagline-container">
            <p className="tagline-line-1">Nothing like</p>
            <p className="tagline-line-2">adding spice to your meal</p>
          </div>

          {/* Action Buttons */}
          <div className="hero-actions">
            <button className="btn-primary" onClick={() => navigate('/shop')}>
              <span>Shop Now</span>
              <FiChevronRight className="btn-icon" />
            </button>
            <button className="btn-secondary" onClick={() => navigate('/shop')}>
              <span>Explore Collection</span>
              <FiArrowRight className="btn-icon" />
            </button>
          </div>

          {/* Stats - Desktop: All in one row, Mobile: 2-1 layout */}
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">{pureStat}%</div>
              <div className="stat-label">Pure & Natural</div>
            </div>
            
            <div className="stat-divider stat-divider-1"></div>
            
            <div className="stat-item">
              <div className="stat-number">{varietiesStat}+</div>
              <div className="stat-label">Spice Varieties</div>
            </div>
            
            <div className="stat-divider stat-divider-2"></div>
            
            <div className="stat-item">
              <div className="stat-number">{customersStat.toLocaleString()}+</div>
              <div className="stat-label">Happy Customers</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="scroll-mouse">
          <div className="scroll-wheel"></div>
        </div>
        <span className="scroll-text">Scroll to explore</span>
      </div>
    </section>
  );
};

export default Hero;